import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { getNotificationSettingsPath } from "utils/router.utils";
import { getItemSession, saveItemSession } from "utils/session";

import DupontButton from "components/DupontButton";
import CustomTabs from "components/Tab";
import TextWithRightArrow from "components/TextWithRightArrow";

import { AlarmPageStrings, RefreshKey } from "../../constants/constantStrings";

import ActiveAlarms from "./ActiveAlarms";
import AlarmHistory from "./AlarmHistory";
import AlarmList from "./AlarmList";

import "./index.css";

const AlarmTabs = () => {
  const location = useLocation();
  const { isAdmin } = useSelector(state => state.user);
  let refreshedTab = JSON.parse(getItemSession(RefreshKey.alarmTabKey));
  refreshedTab = location.state?.tab || refreshedTab || 0;
  const [value, setValue] = useState(refreshedTab);
  const [activeAlarmCount, setActiveAlarmCount] = useState("");
  const [alarmListCount, setAlarmListCount] = useState("");
  const [showAddAlarmDialog, setShowAddAlarmDialog] = useState(false);
  const handleAddAlarm = () => {
    setShowAddAlarmDialog(true);
  };
  const handleAddAlarmClose = () => {
    setShowAddAlarmDialog(false);
  };
  const alarmTabOption = [
    { tabval: AlarmPageStrings.activeAlarm, page: <ActiveAlarms setActiveAlarmCount={setActiveAlarmCount} />, count: activeAlarmCount },
    { tabval: AlarmPageStrings.alarmHistory, page: <AlarmHistory /> },
    {
      tabval: AlarmPageStrings.alarmList,
      page: <AlarmList showAddAlarmDialog={showAddAlarmDialog} setAlarmListCount={setAlarmListCount} handleAddAlarmClose={handleAddAlarmClose} />,
      count: alarmListCount
    }
  ];
  const selectedPage = alarmTabOption[value].page;

  const onTabSelected = value => {
    saveItemSession(RefreshKey.alarmTabKey, JSON.stringify(value));
    setValue(value);
    if (location?.state?.tab) {
      window.history.replaceState(null, "");
    }
  };

  useEffect(() => {
    setValue(refreshedTab);
  }, [refreshedTab]);

  return (
    <div className="alarmContainer">
      <div className="flex">
        <CustomTabs tabOptions={alarmTabOption} tabChangeHandler={onTabSelected} value={value} />
        <div className="alarm-buttons-container">
          {isAdmin && value === 2 && <DupontButton onClick={handleAddAlarm}>{AlarmPageStrings.addAlarm}</DupontButton>}
          <Link to={getNotificationSettingsPath()}>
            <TextWithRightArrow text={AlarmPageStrings.alarmsNotifications} />
          </Link>
        </div>
      </div>
      <div>{selectedPage}</div>
    </div>
  );
};
export default AlarmTabs;
